<script>
import Drawer from "@/components/drawer";
import { required, email } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

// Custom Components
import VueTypeaheadBootstrap from "@/components/vueTypeAheadBootstrap/VueTypeaheadBootstrap";
import GuestForm from "@/components/guestForm/GuestForm";
import BookingService from "@/helpers/APIService/booking.service";
import GuestService from "@/helpers/APIService/guest.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  components: {
    VueTypeaheadBootstrap,
    Drawer,
    GuestForm,
  },
  props: {
    currentProps: Object,
  },
  emits: ["updateDetails"],
  data() {
    return {
      booking: null,
      guest: null,
      guests: null,
      guestList: [],
      cardList: [],
      notes: "",
      amountData: {},
      isDataLoading: true,
      openRoomModal: false,
      room: {},
      copyOfRoomData: [],
      roomChangeTitle: "",
      isRoomDataLoading: false,
      newGuestModal: false,
      newGuestSubmitted: false,
      isNewGuestBtnLoading: false,
      newGuest: {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        mobile: null,
        mobile_iso: "US",
        all: null,
      },
      openNewGuestForm: false,
      editGuest: null,
      editGuestId: null,
      isGuestEdit: false,
      additionalFiledUpdatedData: [],
      isAddFieldBtnLoading: false,
      filterRoom: "all",
    };
  },
  computed: {
    ...authComputed,
    guestProps() {
      return {
        guestId: this.editGuestId,
        isEdit: this.isGuestEdit,
        guest: this.editGuest,
      };
    },
  },
  async mounted() {
    console.log(this.currentProps, "this.currentProps");
    await this.setDetails();
    this.$root.$on("addNewCard", (data) => {
      this.cardList.push(data);
    });
  },
  validations: {
    newGuest: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      email: {
        required,
        email,
      },
      mobile: {
        required,
      },
    },
  },
  methods: {
    // Method is used for set booking detail
    setDetails(status) {
      this.roomChangeTitle = `Select Room From ${
        this.currentProps.booking &&
        this.currentProps.booking.room_type &&
        this.currentProps.booking.room_type.name
          ? this.currentProps.booking.room_type.name
          : "-"
      }`;
      this.booking = this.currentProps.booking;
      this.guest = this.currentProps.booking;
      this.guests =
        this.currentProps.booking && this.currentProps.booking.guest
          ? this.currentProps.booking.guest
          : [];
      this.notes =
        this.currentProps.booking && this.currentProps.booking.notes
          ? this.currentProps.booking.notes
          : "";
      this.cardList = [];
      if (this.currentProps.booking && this.currentProps.booking.guest) {
        this.currentProps.booking.guest.map((item) => {
          item.credit_card.map((card) => {
            this.cardList.push(card);
          });
        });
      }
      this.amountData.due = this.currentProps.booking.reservation_amount;
      this.amountData.paid = this.currentProps.booking.total_received_payment;
      this.amountData.total = this.currentProps.booking.total_balance;
      if (this.currentProps.booking && this.currentProps.booking.room_number) {
        this.room.room_number = this.currentProps.booking.room_number;
      }
      if (status !== "room") {
        this.getGuestList();
      }
    },

    // GUEST RELATED METHODs

    // Method is used for add new guest in booking
    async createNewGuest() {
      this.newGuestSubmitted = true;
      this.isNewGuestBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isNewGuestBtnLoading = false;
        return;
      } else {
        if (this.newGuest.id == null) {
          let guestData = new FormData();
          guestData.append("first_name", this.newGuest.first_name);
          guestData.append("last_name", this.newGuest.last_name);
          guestData.append("email", this.newGuest.email);
          guestData.append("mobile", this.newGuest.mobile);
          guestData.append("hotel", this.hotel.id);

          await GuestService.createGuest(guestData)
            .then(async (guest) => {
              this.isNewGuestBtnLoading = false;
              this.newGuestSubmitted = false;
              this.addGuestInBooking(guest);
              this.getGuestList();
              this.$bvModal.hide("new-guest-modal");
            })
            .catch((error) => {
              this.isNewGuestBtnLoading = false;
              errorHandler(error);
            });
        } else {
          this.isNewGuestBtnLoading = false;
          this.newGuestSubmitted = false;
          this.addGuestInBooking(this.newGuest.all);
          this.$bvModal.hide("new-guest-modal");
        }
      }
    },
    // Method is used for get guest list
    getGuestList() {
      let filter = "";
      GuestService.getGuestList(filter)
        .then((guests) => {
          let temp_booking_guests = [];
          this.guests.map((guest) => {
            temp_booking_guests.push(guest.id);
          });
          let temp_guests = guests.results.filter((guest) => {
            return temp_booking_guests.find((element) => element == guest.id) ==
              undefined
              ? true
              : false;
          });
          this.guestList = [];
          temp_guests.map((guest) => {
            guest.fl_name = guest.first_name + " " + guest.last_name;
            this.guestList.push(guest);
          });
          this.isDataLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for add guest into booking
    addGuestInBooking(guest) {
      const guestData = new FormData();
      guestData.append("guest", guest.id);
      guestData.append("action", "add");
      BookingService.guestInBooking(this.booking.id, guestData)
        .then((response) => {
          this.guests = response;
          this.cardList = [];
          response.map((item) => {
            item.credit_card.map((card) => {
              this.cardList.push(card);
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for remvoe guest form booking
    removeGuestFromBooking(guest_id) {
      Swal.fire({
        title: "Are you sure?",
        text: `You want to remove guest!!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "primary",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes Confirm !",
      }).then((result) => {
        if (result.value) {
          const guestData = new FormData();
          guestData.append("guest", guest_id);
          guestData.append("action", "remove");
          BookingService.guestInBooking(this.booking.id, guestData)
            .then((response) => {
              this.cardList = [];
              this.guests = response;
              response.map((item) => {
                item.credit_card.map((card) => {
                  this.cardList.push(card);
                });
              });
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    handleHit(trackBy, data = null) {
      if (data == null) {
        this.newGuest.id = null;
        this.newGuest.all = null;
      } else {
        this.newGuest.id = data.id;
        this.newGuest.mobile = data.mobile;
        this.newGuest.email = data.email;
        this.newGuest.last_name = data.last_name;
        this.newGuest.first_name = data.first_name;
        this.newGuest.all = data;
      }
    },
    // Method is used for handle guest modal
    closeNewGuestModal() {
      this.newGuestModal = false;
      this.newGuest = {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        mobile: null,
        all: null,
        mobile_iso: "US",
      };
    },
    // Method is used for handle add new guest form
    newGuestForm(guest) {
      if (this.openNewGuestForm == false) {
        this.editGuest = guest;
        this.editGuestId = guest.id;
        this.isGuestEdit = true;
      }
      if (this.openNewGuestForm == true) {
        this.$emit("updateDetails");
        this.isGuestEdit = false;
        this.editGuestId = null;
        this.editGuest = null;

        this.currentProps.booking.guest.map((guest) => {
          if (guest.id === this.currentProps.booking.primary_guest) {
            this.guest = guest;
          }
        });
        this.guests = this.currentProps.booking.guest;
      }
      this.openNewGuestForm = !this.openNewGuestForm;
    },
    // Method is used for handle guest form submission
    handleSubmit(data) {
      this.newGuestForm();
      const name = `${data.first_name} ${data.last_name}`;
      data = { ...data, name };
      this.$root.$emit("UpdateGuestDetails", data);
      this.guests = this.guests.map((item) => {
        if (item.id === data.id) {
          return (item = data);
        } else {
          return item;
        }
      });
    },

    // ROOM RELATED METHODs

    // Method is used for handle update room
    async updateRoom(data) {
      let condition =
        this.room.selectedRoom !== null
          ? data.room_number === this.room.selectedRoom.room_number
          : false;
      if (condition) {
        Middleware.notification("This is already your room !!", "info", 3000);
        this.openRoomModal = !this.openRoomModal;
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: `You want to select room ${data.room_number} on ${data.floor.name}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "primary",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes Sure !",
        }).then((result) => {
          if (result.value) {
            BookingService.updateBooking(this.booking.id, {
              allotted_room: data.id,
            })
              .then(async (response) => {
                this.booking = response;
                this.notes = response.notes;
                Middleware.notification(
                  "Room allocation successfully !!",
                  "success",
                  3000
                );
                this.$root.$emit("UpdateRoom", {
                  ...response,
                  bookingId: response.id,
                });
                this.room.room_number = response.room_number;
                if (!this.currentProps.booking.is_room_allocate_done) {
                  this.currentProps.booking.is_room_allocate_done = true;
                }
                this.openRoomModal = !this.openRoomModal;
              })
              .catch((error) => {
                errorHandler(error);
              });
          }
        });
      }
    },
    // Method is used for handle edit room details
    editRoom() {
      this.isRoomDataLoading = true;
      this.openRoomModal = !this.openRoomModal;
      let filterData = `?check_in_date=${this.booking.check_in_date}&check_out_date=${this.booking.check_out_date}`;

      if (this.booking && this.booking.room_type && this.booking.room_type.id) {
        filterData += `&room_type=${this.booking.room_type.id}`;
      }

      BookingService.getRoomNoAvailabilityByRoomType(filterData)
        .then((roomData) => {
          if (
            this.currentProps.booking &&
            this.currentProps.booking.room_number
          ) {
            this.room.selectedRoom = {
              ...this.booking.allotted_room,
              isSelected: true,
            };
            roomData = [this.room.selectedRoom, ...roomData];
          } else {
            this.room.selectedRoom = null;
          }
          this.room.roomData = roomData;
          this.copyOfRoomData = roomData;
          this.isRoomDataLoading = false;
          this.setDetails("room");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for fitelr room
    filterRoomBased() {
      this.isRoomDataLoading = true;
      if (this.filterRoom == "all") {
        this.room.roomData = this.copyOfRoomData;
      } else {
        if (this.room.roomData.length == 0) {
          this.room.roomData = this.copyOfRoomData;
        }
        this.room.roomData = this.room.roomData.filter(
          (item) => item[this.filterRoom]
        );
        this.isRoomDataLoading = false;
      }
    },
    // Method is used for handle to auto assign room
    autoAssignRoom() {
      const randomRoom = Math.floor(Math.random() * this.room.roomData.length);
      const roomId = this.room.roomData[randomRoom].id;
      BookingService.updateBooking(this.booking.id, { allotted_room: roomId })
        .then(async (response) => {
          this.room.room_number = response.room_number;
          Middleware.notification(
            "Room allocation auccessfully !!",
            "success",
            3000
          );
          this.$root.$emit("UpdateRoom", {
            ...response,
            bookingId: response.id,
          });
          this.room.room_number = response.room_number;
          if (!this.currentProps.booking.is_room_allocate_done) {
            this.currentProps.booking.is_room_allocate_done = true;
          }
          this.openRoomModal = !this.openRoomModal;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },

    // Method is used for handle upfate addtion filed answer
    updateAdditionalFiledAnswer(answer, data) {
      data = { ...data, value: answer };
      this.additionalFiledUpdatedData = this.booking.additional_field.map(
        (item) => {
          if (item.key == data.section_label) {
            item.value = item.value.map((vItem) => {
              if (vItem.field_text == data.field_text) {
                vItem = data;
              }
              return vItem;
            });
          }
          return item;
        }
      );
    },
    // Method is used for handle update additional filed
    updateAdditionalFiled() {
      this.isAddFieldBtnLoading = true;
      BookingService.updateBooking(this.currentProps.booking.id, {
        additional_field: this.additionalFiledUpdatedData,
      })
        .then((response) => {
          this.currentProps.booking.additionalFiledUpdatedData =
            response.additionalFiledUpdatedData;
          Middleware.notification("Updated successfully !!", "success", 3000);

          this.isAddFieldBtnLoading = false;
        })
        .catch((error) => {
          this.isAddFieldBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is used for update notes
    updateNotes() {
      BookingService.updateBooking(this.currentProps.booking.id, {
        notes: this.notes,
      })
        .then((response) => {
          this.currentProps.booking.notes = response.notes;
          Middleware.notification(
            "Notes updated successfully !!",
            "success",
            3000
          );
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for handle country change
    countryChange(code) {
      this.newGuest.mobile_iso = code.iso2;
    },
    // Method is used for handle copy code
    copyCode(code) {
      Middleware.copyCode(code);
    },
    // Method is used for generate avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
  },
};
</script>

<template>
  <b-tab active>
    <template v-slot:title>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">Overview</span>
    </template>
    <!-- First with origin and balance -->
    <div class="row" id="overview" v-if="!isDataLoading">
      <div class="col-md-7">
        <b-card>
          <b-card-header>
            <h6 class="mb-0 card-header-text fw-normal">PAYMENT SUMMARY</h6>
          </b-card-header>
          <div class="overview-box">
            <div class="row">
              <div class="col-md-6">
                <p class="p-2 pb-0 mb-2 fw-bold gray-text">CHARGES</p>
                <hr class="my-2" />
                <div class="d-flex align-items-center">
                  <p class="px-2 font-weight-semibold mb-0">
                    Charges :
                    <span class="text-danger"
                      >{{ booking.currency === "usd" ? "$" : "₹"
                      }}{{ booking.total_charge }}</span
                    >
                  </p>
                  <p class="px-2 font-weight-semibold mb-0">
                    Payments :
                    <span class="text-danger"
                      >{{ booking.currency == "usd" ? "$" : "₹"
                      }}{{ booking.total_payment }}</span
                    >
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <p class="p-2 pb-0 mb-2 fw-bold gray-text">SECURITY DEPOSIT</p>
                <hr class="my-2" />
                <div class="d-flex align-items-center">
                  <span class="px-2 font-weight-semibold"
                    >Balance : {{ booking.currency == "usd" ? "$" : "₹"
                    }}<span class="text-danger">{{
                      booking.current_balance
                    }}</span></span
                  >
                  <span class="px-2 font-weight-semibold"
                    >S. Deposit(Hold) :
                    {{ booking.currency == "usd" ? "$" : "₹"
                    }}<span class="text-danger">{{
                      booking.security_deposit_on_hold
                    }}</span></span
                  >
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-5">
        <b-card>
          <b-card-header>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0 card-header-text fw-normal">ORIGIN</h6>
              <div class="overflow-tip w-auto">
                {{
                  booking.booking_source && booking.booking_source.name
                    ? booking.booking_source.name
                    : "-"
                }}
                <span
                  class="fw-bold px-1 m-0"
                  @click="
                    copyCode(
                      booking.booking_source_reference_no !== null
                        ? booking.booking_source_reference_no
                        : booking.reference_no
                    )
                  "
                  >#{{
                    booking.booking_source_reference_no !== null
                      ? booking.booking_source_reference_no
                      : booking.reference_no
                  }}</span
                >
              </div>
            </div>
          </b-card-header>
          <div class="overview-box">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Company</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="guest !== null">
                      {{ guest.title }}
                      {{ guest.last_name + " " + guest.first_name }}
                    </td>
                    <td>
                      {{
                        booking.company !== null ? booking.company.name : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!--First on loader -->
    <div class="row" id="overview" v-else>
      <div class="col-md-7">
        <b-card>
          <b-card-header>BALANCE</b-card-header>
          <div class="overview-box">
            <div class="row">
              <div class="col-md-6">
                <p class="pt-2 ps-3 fw-bold gray-text">CHARGES</p>
                <hr />
                <p>
                  <span class="ms-3 me-2"
                    ><b class="placeholder-glow">Charges : </b>
                    <span class="placeholder placeholder-lg w-reload-50"></span>
                  </span>
                  <span class="ms-3"
                    ><b class="placeholder-glow">Payments : </b>
                    <span class="placeholder placeholder-lg w-reload-50"></span>
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p class="pt-2 fw-bold gray-text">SECURITY DEPOSIT</p>
                <hr />
                <p>
                  <span class="ms-1"
                    ><b class="placeholder-glow">Balance : </b>
                    <span class="placeholder placeholder-lg w-reload-50"></span>
                  </span>
                  <span class="ms-3"
                    ><b class="placeholder-glow">S. Deposit(Hold) : </b>
                    <span class="placeholder placeholder-lg w-reload-50"></span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-5">
        <b-card>
          <b-card-header>
            ORIGIN
            <span class="float-end"> </span>
          </b-card-header>
          <div class="overview-box">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Company</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Second date of stay and card on file-->
    <div class="row" id="overview" v-if="!isDataLoading">
      <div class="col-md-7">
        <b-card>
          <b-card-header>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="card-header-text fw-normal mb-0">DATE OF STAY</h6>

              <span> Total Rooms : {{ 1 }} </span>
            </div>
          </b-card-header>
          <div class="overview-box">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Room Type</th>
                    <th>Room</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="currentProps.booking !== null">
                      {{
                        global_format_date(currentProps.booking.check_in_date)
                      }}
                    </td>
                    <td>
                      {{
                        global_format_date(currentProps.booking.check_out_date)
                      }}
                    </td>
                    <td>
                      {{
                        booking.room_type && booking.room_type.name
                          ? booking.room_type.name
                          : "-"
                      }}
                    </td>
                    <td>
                      {{ room.room_number }}
                      <i
                        class="fas fa-pencil-alt text-success ms-1"
                        v-b-popover.hover.top="'Update room'"
                        id="edit"
                        v-b-modal.open-room-modal
                        @click="editRoom()"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-md-5">
        <b-card>
          <b-card-header>
            <h6 class="card-header-text fw-normal mb-0">CARD ON FILE</h6>
          </b-card-header>
          <div class="overview-box">
            <div class="cards">
              <template v-for="card in cardList">
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-if="card.card_brand === 'visa'"
                  :key="card.id"
                >
                  <img src="@/assets/images/brands/visa.png" alt="visa card" />
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="ms-2"
                  />
                </p>
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-else-if="card.card_brand === 'dcvr'"
                  :key="card.id + 1"
                >
                  <i class="fab fa-cc-visa text-dark"></i>
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/brands/emv-card-chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="me-1"
                  />
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                </p>
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-else-if="card.card_brand === 'amex'"
                  :key="card.id + 2"
                >
                  <i class="fab fa-cc-visa text-dark"></i>
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/brands/emv-card-chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="me-1"
                  />
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                </p>
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-else-if="card.card_brand === 'dclb'"
                  :key="card.id + 5"
                >
                  <i class="fab fa-cc-visa text-dark"></i>
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/brands/emv-card-chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="me-1"
                  />
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                </p>
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-else-if="card.card_brand === 'm/c'"
                  :key="card.id + 3"
                >
                  <img src="@/assets/images/brands/master.png" alt="master" />
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="ms-2"
                  />
                </p>
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-else-if="card.card_brand === 'jcb'"
                  :key="card.id + 4"
                >
                  <img src="@/assets/images/brands/jcb.png" alt="master" />
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/brands/emv-card-chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="me-1"
                  />
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                </p>
                <p
                  class="d-flex align-items-center mx-2 my-1"
                  v-else
                  :key="card.id + 6"
                >
                  <img src="@/assets/images/brands/other.png" alt="master" />
                  <span class="ms-2 card-width">{{
                    "XXXX XXXX XXXX " + card.last_digit
                  }}</span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/brands/emv-card-chip.png"
                    id="emv_card"
                    alt="emv chip"
                    class="me-1"
                  />
                  <span>
                    <i
                      class="far fas fa-check-circle text-success img-fluid fs-5"
                      v-if="
                        card.id === currentProps.booking.default_credit_card
                      "
                    ></i>
                    <i class="far fa-check-circle fs-5" v-else></i>
                  </span>
                </p>
              </template>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Second loader -->
    <div class="row" id="overview" v-if="isDataLoading">
      <div class="col-md-7">
        <b-card>
          <b-card-header
            >DATE OF STAY
            <span class="text-end placeholder-glow float-end">
              <span class="placeholder w-100 placeholder-lg"> </span>
            </span>
          </b-card-header>
          <div class="overview-box">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Room Type</th>
                    <th>Room</th>
                  </tr>
                </thead>
                <tbody>
                  <template>
                    <tr v-for="number in 1" :key="number">
                      <td class="placeholder-glow" v-for="no in 4" :key="no">
                        <span class="placeholder w-100 placeholder-lg"></span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-md-5">
        <b-card>
          <b-card-header
            >CARD ON FILE
            <span class="badge align-items-center px-2 float-end card-badge">
            </span>
          </b-card-header>
          <div class="overview-box">
            <div class="placeholder-glow cards">
              <template>
                <p class="placeholder placeholder-lg mx-3 w-75">
                  {{ "XXXX XXXX XXXX XXXX" }}
                </p>
                <p class="placeholder placeholder-lg mx-3 w-75">
                  {{ "XXXX XXXX XXXX XXXX" }}
                </p>
              </template>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Third guest and notes -->
    <div class="row" id="overview" v-if="!isDataLoading">
      <div class="col-md-7">
        <b-card>
          <b-card-header>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="card-header-text fw-normal mb-0">
                GUEST ({{
                  currentProps.booking &&
                  currentProps.booking.guest &&
                  currentProps.booking.guest.length
                    ? currentProps.booking.guest.length
                    : 0
                }})
              </h6>
              <span>
                <b-button
                  v-b-modal.new-guest-modal
                  variant="primary"
                  @click="newGuestModal = true"
                  class="btn-sm"
                >
                  <i class="fas fa-plus font-size-10"></i>
                </b-button>
              </span>
            </div>
          </b-card-header>
          <div class="overview-box">
            <div class="row mb-2" v-for="(item, index) in guests" :key="index">
              <div class="col-md-12">
                <div class="d-flex align-items-center px-2">
                  <img
                    v-if="item.selfie_image != null"
                    class="rounded-circle picture-img"
                    :src="item.selfie_image"
                    alt="Avatar"
                  />
                  <div v-else>
                    <span
                      class="d-flex align-items-center justify-content-center bg-soft bg-primary text-secondary font-20 rounded-circle picture-img"
                    >
                      {{
                        avatarGenerator(item.last_name + " " + item.first_name)
                      }}
                    </span>
                  </div>
                  <div class="guestInfo">
                    <div class="d-flex align-items-end">
                      <div>
                        <div>
                          <span class="fw-bold">
                            {{ item.title }}
                            {{ item.last_name + " " + item.first_name }}
                          </span>
                        </div>
                        <div class="d-flex">
                          <div class="w-reload-144">
                            <i class="fas fa-phone-alt" v-if="item.mobile"></i>
                            {{ item.mobile }}
                          </div>
                          <div class="card-width text-truncate me-2">
                            <i class="fas fa-envelope" v-if="item.email"></i>
                            {{ item.email }}
                          </div>
                        </div>
                      </div>
                      <div class="d-flex">
                        <span
                          class="badge align-items-center card-badge"
                          :class="[
                            item.doc_image_status !== 'V' ||
                            item.selfie_image_status !== 'V'
                              ? 'badge-soft-danger'
                              : 'badge-soft-success',
                          ]"
                        >
                          {{
                            item.doc_image_status !== "V" ||
                            item.selfie_image_status !== "V"
                              ? "Not Verified"
                              : "Verified"
                          }}
                        </span>
                        <i
                          class="fas fa-pencil-alt ms-2"
                          @click="newGuestForm(item)"
                        ></i>
                        <i
                          v-if="item.id !== booking.primary_guest.id"
                          class="ms-2 fas fa-trash"
                          @click="removeGuestFromBooking(item.id)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-5">
        <b-card>
          <b-card-header>
            <h6 class="card-header-text fw-normal mb-0">COMMENT & NOTES</h6>
          </b-card-header>
          <div class="overview-box px-2">
            <b-form-textarea
              name="notes"
              id="notes"
              placeholder="Type Here"
              v-model="notes"
              @blur="updateNotes"
              rows="3"
              class="border-0"
            ></b-form-textarea>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Third loader -->
    <div class="row" id="overview" v-if="isDataLoading">
      <div class="col-md-7">
        <b-card>
          <b-card-header>GUEST </b-card-header>
          <div class="overview-box">
            <div class="row placeholder-glow" v-for="number in 2" :key="number">
              <div class="col-md-2">
                <img
                  alt="200x200"
                  src="@/assets/images/users/avatar.jpg"
                  data-holder-rendered="true"
                  class="rounded-circle avatar-md border border-dark mx-auto d-block placeholder placeholder-lg"
                />
              </div>
              <div class="col-md-8 placeholder-glow guestInfo">
                <p
                  class="placeholder placeholder-lg w-reload-100 me-2 mb-0"
                ></p>
                <p
                  class="placeholder placeholder-lg w-reload-144 me-2 mb-0"
                ></p>
                <p
                  class="placeholder placeholder-lg w-reload-100 me-2 mb-0"
                ></p>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-5">
        <b-card>
          <b-card-header>COMMENT & NOTES</b-card-header>
          <div class="overview-box px-2 placeholder-glow">
            <b-form-textarea
              class="placeholder w-100 placeholder-lg"
              name="notes"
              id="notes"
              placeholder="Type Here"
              rows="3"
            ></b-form-textarea>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Fourth For Additional field  -->
    <div class="row" id="overview" v-if="booking != null && !isDataLoading">
      <div class="col-md-12" v-if="booking.additional_field !== null">
        <b-card>
          <b-card-header>
            <h6 class="card-header-text fw-normal mb-0">Additional Field</h6>
          </b-card-header>
          <div class="p-3">
            <div
              v-for="(addField, index) in booking.additional_field"
              :key="index"
            >
              <h5>
                {{ addField.key }}
              </h5>
              <div class="row">
                <div
                  class="col-md-4"
                  v-for="item in addField.value"
                  :key="item.field_label"
                >
                  <div class="mb-3">
                    <label for="addField">{{ item.field_text }}</label>
                    <b-form-input
                      :key="index"
                      :name="item.field_label"
                      :id="item.field_label"
                      placeholder="update field value"
                      v-model.trim="item.value"
                      @blur="
                        updateAdditionalFiledAnswer(
                          $event.target.value,
                          addField
                        )
                      "
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <b-button
              class="float-end mb-2"
              variant="outline-primary"
              :class="{ disabled: isAddFieldBtnLoading }"
              @click="updateAdditionalFiled"
            >
              <i
                v-if="isAddFieldBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Update Answer
            </b-button>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Fourth is loading -->
    <div class="row" id="overview" v-if="isDataLoading">
      <div class="col-md-12">
        <b-card>
          <b-card-header>
            <h6 class="card-header-text fw-normal mb-0">Additional Field</h6>
          </b-card-header>
          <div class="p-3">
            <div class="row">
              <div class="col-md-4" v-for="no in 6" :key="no">
                <div class="placeholder-glow">
                  <div class="placeholder w-100 placeholder-lg m-0 mb-3"></div>
                </div>
              </div>
              <div class="col-md-2 offset-md-10">
                <div
                  class="mb-2 w-100 placeholder placeholder-lg"
                  disabled
                ></div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!-- Open edit room and status -->
    <b-modal
      v-if="openRoomModal"
      id="open-room-modal"
      size="lg"
      centered
      hide-footer
      :title="roomChangeTitle"
      @hidden="openRoomModal = false"
    >
      <div class="row">
        <div class="col-md-10">
          <div class="d-flex align-items-center mb-3">
            <label class="mb-0"> Filter Room</label>
            <span class="mx-2">:</span>
            <b-form-select
              class="form-select w-75"
              id="room_filter"
              type="text"
              autocomplete="off"
              :options="[
                {
                  text: 'All',
                  value: 'all',
                },
                {
                  text: 'Accessible',
                  value: 'is_accessible',
                },
                {
                  text: 'Smoking',
                  value: 'is_smoking',
                },
                {
                  text: 'Pet Friendly',
                  value: 'is_pet_friendly',
                },
              ]"
              v-model="filterRoom"
              @change="filterRoomBased()"
            >
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2" v-if="booking.allotted_room == null">
          <b-button class="float-end" @click="autoAssignRoom"
            >Auto Assign</b-button
          >
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="fixTableHead">
          <div class="col-md-12">
            <table
              class="table table-hover mb-0"
              ref="my-table"
              infinite-scroll-disabled="busy"
              infinite-scroll-distance="10"
            >
              <thead class="table-light">
                <tr>
                  <th>Room Number</th>
                  <th>Floor</th>
                  <th>FD Status</th>
                  <th>HSK Status</th>
                  <th>Available</th>
                </tr>
              </thead>
              <tbody v-if="isRoomDataLoading">
                <tr v-for="(item, index) in 10" :key="index">
                  <td class="placeholder-glow" v-for="no in 5" :key="no">
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr
                  v-for="(room, index) in room.roomData"
                  :key="index"
                  :class="room.isSelected ? 'bg-primary bg-soft' : ''"
                  @click="updateRoom(room)"
                >
                  <td>
                    {{ room.room_number }}
                    <i
                      class="fas fa-exchange-alt"
                      v-if="
                        room.connect_room_number !== 'null' &&
                        room.connect_room_number !== null
                      "
                    ></i>
                    {{
                      room.connect_room_number !== "null" &&
                      room.connect_room_number !== null
                        ? room.connect_room_number
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      room && room.floor && room.floor.name
                        ? room.floor.name
                        : "-"
                    }}
                  </td>
                  <td>
                    <span
                      class="badge align-items-center py-1 px-2 card-badge"
                      :class="[
                        room.occupancy_status == 'v'
                          ? 'badge-soft-primary'
                          : room.occupancy_status == 'o'
                          ? 'badge-soft-success'
                          : room.occupancy_status == 'b'
                          ? 'badge-soft-dark'
                          : room.occupancy_status == 'ooo'
                          ? 'badge-soft-warning'
                          : room.occupancy_status == 'oos'
                          ? 'badge-soft-danger'
                          : 'badge-soft-dark',
                      ]"
                    >
                      {{
                        room.occupancy_status == "v"
                          ? "Vacant"
                          : room.occupancy_status == "o"
                          ? "Occupied"
                          : room.occupancy_status == "b"
                          ? "Blocked"
                          : room.occupancy_status == "ooo"
                          ? "Out of Order"
                          : "Out of Service"
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="badge align-items-center py-1 px-2 card-badge"
                      :class="[
                        room.hk_status == 'p'
                          ? 'badge-soft-warning'
                          : room.hk_status == 'c'
                          ? 'badge-soft-success'
                          : room.hk_status == 'd'
                          ? 'badge-soft-dark'
                          : 'badge-soft-danger',
                      ]"
                    >
                      {{
                        room.hk_status == "p"
                          ? "Pickup"
                          : room.hk_status == "c"
                          ? "Clean"
                          : "Dirty"
                      }}
                    </span>
                  </td>
                  <td>
                    <i
                      class="fas fa-wheelchair fs-5 me-3"
                      v-if="room.is_accessible"
                    ></i>
                    <i
                      class="fas fa-paw fs-5 me-3"
                      v-if="room.is_pet_friendly"
                    ></i>
                    <i
                      class="fas fa-smoking fs-5 me-3"
                      v-if="room.is_smoking"
                    ></i>
                    {{
                      room.is_accessible ||
                      room.is_pet_friendly ||
                      room.is_smoking
                        ? ""
                        : "-"
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!isRoomDataLoading && room.roomData.length == 0">
                <tr>
                  <td colspan="9" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Room Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal is use for add new guest in booking  -->
    <b-modal
      v-if="newGuestModal"
      id="new-guest-modal"
      centered
      title="Add Guest"
      @hidden="closeNewGuestModal"
      @ok="createNewGuest"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <b-form-group class="mb-3" label="Email" label-for="email-input">
              <template slot="label">
                Email <span class="text-danger">*</span>
              </template>
              <vue-typeahead-bootstrap
                v-model="newGuest.email"
                @hit="handleHit"
                :data="guestList"
                trackby="email"
                :class="{
                  'is-invalid': newGuestSubmitted && $v.newGuest.email.$error,
                }"
                placeholder="Enter email"
              />
              <div v-if="newGuestSubmitted" class="invalid-feedback">
                <span v-if="!$v.newGuest.email.required"
                  >email is required.</span
                >
                <span v-if="!$v.newGuest.email.email">email is not valid.</span>
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <b-form-group class="mb-3" label="Mobile" label-for="mobile-input">
            <template slot="label">
              Mobile <span class="text-danger">*</span>
            </template>
            <vue-tel-input
              v-model="newGuest.mobile"
              :autoFormat="true"
              :autoDefaultCountry="false"
              :defaultCountry="newGuest.mobile_iso"
              :dropdownOptions="{
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                width: '390px',
                showSearchBox: true,
              }"
              @country-changed="countryChange(...arguments)"
              :class="{
                'is-invalid': newGuestSubmitted && $v.newGuest.mobile.$error,
              }"
            ></vue-tel-input>
            <div v-if="newGuestSubmitted" class="invalid-feedback">
              <span v-if="!$v.newGuest.mobile.required"
                >mobile number is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 mb-3">
          <b-form-group
            class="mb-3"
            label="First Name"
            label-for="first-name-input"
          >
            <template slot="label">
              First Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="first-name-input"
              type="text"
              autocomplete="off"
              placeholder="First Name"
              v-model="newGuest.first_name"
              :class="{
                'is-invalid':
                  newGuestSubmitted && $v.newGuest.first_name.$error,
              }"
            ></b-form-input>
            <div v-if="newGuestSubmitted" class="invalid-feedback">
              <span v-if="!$v.newGuest.first_name.required"
                >first name is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 mb-3">
          <b-form-group
            class="mb-3"
            label="Last Name"
            label-for="last-name-input"
          >
            <template slot="label">
              Last Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="last-name-input"
              type="text"
              autocomplete="off"
              placeholder="Last Name"
              v-model="newGuest.last_name"
              :class="{
                'is-invalid': newGuestSubmitted && $v.newGuest.last_name.$error,
              }"
            ></b-form-input>
            <div v-if="newGuestSubmitted" class="invalid-feedback">
              <span v-if="!$v.newGuest.last_name.required"
                >last name is required.</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
      <template #modal-footer>
        <div class="row">
          <div class="col-12">
            <b-button
              variant="primary"
              @click="createNewGuest"
              :class="{ disabled: isNewGuestBtnLoading }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isNewGuestBtnLoading"
              ></i>
              Save
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Open guest form model -->
    <Drawer
      @close="newGuestForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewGuestForm">
        <GuestForm
          :currentProps="guestProps"
          @submitted="handleSubmit"
          @cancelSubmit="newGuestForm"
        ></GuestForm>
      </div>
    </Drawer>
  </b-tab>
</template>

<style scoped>
.card-header {
  padding-left: 13px;
}

#overview .card-body {
  padding: 0px;
}

.guestInfo {
  padding: 10px;
  display: flex;
}

.cards p {
  letter-spacing: 6px;
}

.cards img {
  height: 30px;
  width: 30px;
}

.overview-box {
  min-height: 129.5px;
}

.card-header-text {
  color: #74788d;
}

.gray-text {
  color: #6e6e6e;
}

.w-reload-50 {
  width: 50px;
}

.w-reload-100 {
  width: 100px;
}

.w-reload-144 {
  width: 144px;
}

.card-width {
  width: 320px;
}
</style>
